/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPlanChangeApprovalRequestRejectResponseData,
    PostPlanChangeApprovalRequestRejectResponseDataFromJSON,
    PostPlanChangeApprovalRequestRejectResponseDataFromJSONTyped,
    PostPlanChangeApprovalRequestRejectResponseDataToJSON,
} from './PostPlanChangeApprovalRequestRejectResponseData';

/**
 * 
 * @export
 * @interface PostPlanChangeApprovalRequestRejectResponse
 */
export interface PostPlanChangeApprovalRequestRejectResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostPlanChangeApprovalRequestRejectResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestRejectResponse
     */
    message: string;
    /**
     * 
     * @type {PostPlanChangeApprovalRequestRejectResponseData}
     * @memberof PostPlanChangeApprovalRequestRejectResponse
     */
    data: PostPlanChangeApprovalRequestRejectResponseData;
}

export function PostPlanChangeApprovalRequestRejectResponseFromJSON(json: any): PostPlanChangeApprovalRequestRejectResponse {
    return PostPlanChangeApprovalRequestRejectResponseFromJSONTyped(json, false);
}

export function PostPlanChangeApprovalRequestRejectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPlanChangeApprovalRequestRejectResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPlanChangeApprovalRequestRejectResponseDataFromJSON(json['data']),
    };
}

export function PostPlanChangeApprovalRequestRejectResponseToJSON(value?: PostPlanChangeApprovalRequestRejectResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPlanChangeApprovalRequestRejectResponseDataToJSON(value.data),
    };
}

